class Hitbox{
    constructor({ root, offset, size}){
        this.root = root;
        this.offset = offset;
        this.size = size;
    }

    get center(){
        const p = this.root.position;
        return  new THREE.Vector3(p.x + this.offset.x, p.y + this.offset.y, p.z + this.offset.z);
    }

    get corners(){
        const corners = [];
        const c = this.center;
        for(let x=-1; x<2; x+=2){
            for(let y=-1; y<2; y+=2){
                for(let z=-1; z<2; z+=2){
                    corners.push(new THREE.Vector3(c.x + this.size.x * .5 * x, c.y + this.size.y * .5 * y, c.z + this.size.z * .5 * z));
                }
            }
        }
        return corners;
    }

    overlapsPoint(p){
        const corners = this.corners;
        const a = corners[0];
        const b = corners[7];
        return  a.x <= p.x && p.x <= b.x && 
                a.y <= p.y && p.y <= b.y && 
                a.z <= p.z && p.z <= b.z;
    }

    overlaps(hitbox){
        const corners = hitbox.corners;
        for(let i=0; i<corners.length; i++){
            if(this.overlapsPoint(corners[i])) 
                return true;
        }
        return false;
    }

    createDebugMesh(){
        const geometry = new THREE.BoxGeometry();
        const material = new THREE.MeshBasicMaterial({color: "green", wireframe: true});
        const cube = new THREE.Mesh( geometry, material );
        cube.scale.set(this.size.x, this.size.y, this.size.z);
        return cube;
    }
}

export { Hitbox };